export default "/assets/images/mama-small.529e827325c7cf77.webp";